import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";
import CKEditorInput from "../../../utils/forms/CKEditorInput";

// Components
import Loader from "../../utils/Loader";
import PermalinkField from "../../utils/PermalinkField";
import DeleteConfirmationDialog from "../../utils/dialogs/DeleteConfirmationDialog";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { getNews } from "../../../store/actions/news";

// CSS
import "../../../css/forms/custom-checkbox.css";
import "../../../css/forms/datepicker.css";

// Utils
import {
	handleKeyPress,
	handleInputChange,
	handleCheckboxClick,
	editorChange,
	handleDateChange
} from "../../../utils/forms/inputHandling";

class AdminNewsForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				id: !!props.match.params.id ? props.match.params.id : "",
				title: "",
				permalink: "",
				content: "",
				active: 1,
				date_posted: moment()
			},
			isLoading: !!props.match.params.id ? true : false,
			addSucccess: !!props.location.state ? props.location.state.successMessage : "",
			updateLoading: false,
			updateErrors: {},
			updateSuccess: "",
			showDeleteConfirmationDialog: false,
			deletionInProgress: false,
			deleteErrors: "",
			deleteSuccess: ""
		};

		this.CKEditorInput = new CKEditorInput();

		// Remove state from history object (success messages, etc)
		if (!!props.location.state) {
			props.history.replace({
				pathname: props.history.location.pathname
			});
		}
	}

	// ===================================================================================
	//  LIFE CYCLE
	// ===================================================================================
	componentDidMount() {
		if (this.state.data.id) {
			this.loadData();
		}
	}

	async loadData() {
		let resp = await this.props.getNews(this.state.data.id, this.props.user.token);

		// If no response, bail
		if (!resp || !resp.data.data.id) {
			this.setState({
				isLoading: false
			});
			return;
		}

		// Ensure dates are valid
		let date_posted = moment(
			moment
				.utc(resp.data.data.date_posted)
				.local()
				.format()
		);

		date_posted = !date_posted.isValid() ? date_posted : moment();

		const data = {
			...resp.data.data,
			date_posted
		};

		// Set the component's data
		this.setState({
			data,
			isLoading: false
		});

		// this.props
		// 	.getNews(this.state.data.id, this.props.user.token)
		// 	.then(resp => {
		// 		// If no response, bail
		// 		if (!resp || !resp.data.data.id) {
		// 			this.setState({
		// 				isLoading: false
		// 			});
		// 			return;
		// 		}

		// 		// Ensure dates are valid
		// 		let date_posted = moment(
		// 			moment
		// 				.utc(resp.data.data.date_posted)
		// 				.local()
		// 				.format()
		// 		);

		// 		date_posted = !date_posted.isValid() ? date_posted : moment();

		// 		const data = {
		// 			...resp.data.data,
		// 			date_posted
		// 		};

		// 		// Set the component's data
		// 		this.setState({
		// 			data,
		// 			isLoading: false
		// 		});
		// 	});
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit = () => {
		const { user } = this.props;
		const { data } = this.state;

		data.language = process.env.REACT_APP_LANGUAGE;

		this.setState({
			addSucccess: "",
			updateErrors: {},
			updateLoading: true,
			updateSuccess: ""
		});

		this.CKEditorInput.setCKReadonly(true);

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(process.env.REACT_APP_API_URL + "news", data, { headers: AUTH_HEADER })
			.then(response => {
				this.CKEditorInput.setCKReadonly(false);

				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					// Redirect to store edit route
					if (!data.id) {
						this.props.history.push({
							pathname: "/admin/news/edit/" + response.data.data.id,
							state: {
								successMessage: response.data.message
							}
						});

						return;
					}

					// Staying on this page and all done. So just set some state.
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				this.CKEditorInput.setCKReadonly(false);

				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	};

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete() {
		const { user } = this.props;

		this.setState({
			deletionInProgress: true,
			deleteErrors: {},
			deleteSuccess: ""
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.delete(process.env.REACT_APP_API_URL + "news/" + this.state.data.id, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.response.data.error
							? err.response.data.error
							: err.response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.message
					});
				}
			});
	}

	handleDeleteRedirect() {
		this.props.history.push("/admin/news/edit/");
	}

	render() {
		const { data, addSucccess, updateErrors, updateSuccess, updateLoading } = this.state;
		const { id, title, permalink, date_posted, content, active } = data;

		return (
			<React.Fragment>
				{!this.props.match.params.id && <h1>Add News</h1>}

				{/* Loading */}
				{this.state.isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<React.Fragment>
						{/* Success */}
						{!!addSucccess && <SuccessWrap animate={1}>{addSucccess}</SuccessWrap>}

						{/* General error (record load error) */}
						{!!this.props.newsError && (
							<ErrorWrap animate={1}>{this.props.newsError}</ErrorWrap>
						)}

						{/* Record not found */}
						{!!id && !!this.props.newsItem && !this.props.newsItem.id && (
							<ErrorWrap animate={1}>{"Unable to find record"}</ErrorWrap>
						)}

						{/* Show form if adding new item, or item was selected and found */}
						{(!id || (id && !!this.props.newsItem && this.props.newsItem.id)) && (
							<React.Fragment>
								{!!id && <input type="hidden" id="id" value={id} />}

								<div className="fieldset">
									<div className="form-field">
										<label>Title:</label>

										{!!updateErrors.title && (
											<ErrorWrap animate={1}>{updateErrors.title}</ErrorWrap>
										)}
										<input
											type="text"
											id="title"
											value={title}
											maxLength="255"
											disabled={updateLoading}
											onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
											onChange={e => {
												this.setState(handleInputChange(e, this.state));
											}}
										/>
									</div>

									<div className="form-field">
										<label>Permalink:</label>

										{!!updateErrors.permalink && (
											<ErrorWrap animate={1}>
												{updateErrors.permalink}
											</ErrorWrap>
										)}
										<PermalinkField
											tableName={"news_t"}
											id={id}
											value={permalink}
											controlFieldValue={title}
											fieldError={updateErrors.permalink}
											handleSubmit={this.handleSubmit.bind(this)}
											handleChange={res =>
												this.setState({
													data: {
														...this.state.data,
														permalink: res
													}
												})
											}
										/>
									</div>

									<div className="form-field">
										<label>Content:</label>

										{!!updateErrors.content && (
											<ErrorWrap animate={1}>
												{updateErrors.content}
											</ErrorWrap>
										)}
										<CKEditor
											scriptUrl="/ckeditor/ckeditor.js"
											content={content}
											config={{
												filebrowserBrowseUrl: "/file-browser",
												uploadUrl: process.env.REACT_APP_API_URL + `files`
											}}
											events={{
												instanceReady: editorReady.bind(this),
												change: e =>
													editorChange(
														"content",
														e,
														this.state
													).then(res => this.setState(res))
											}}
											ref={instance => {
												this.CKEditorInput.addEditor("content", instance);
											}}
										/>
									</div>

									<div className="form-field">
										<label>Date Posted:</label>

										{!!updateErrors.date_posted && (
											<ErrorWrap animate={1}>
												{updateErrors.date_posted}
											</ErrorWrap>
										)}
										<DatePicker
											className="date"
											selected={date_posted}
											disabled={updateLoading}
											onChange={e =>
												handleDateChange(
													e,
													"date_posted",
													this.state
												).then(res => this.setState(res))
											}
											showTimeSelect
											dateFormat="LLL"
											placeholderText="Click to select a date"
										/>
									</div>

									<div className="form-field checkbox">
										{!!updateErrors.hidden && (
											<ErrorWrap animate={1}>{updateErrors.active}</ErrorWrap>
										)}
										<div
											className={`custom-label checkbox-label${
												updateLoading ? " disabled-label" : ""
											}`}
										>
											<input
												type="checkbox"
												id="active"
												value="1"
												checked={active}
												disabled={updateLoading}
												onChange={e =>
													handleCheckboxClick(e, this.state).then(res =>
														this.setState(res)
													)
												}
											/>
											<label htmlFor="active">Active</label>
										</div>
									</div>
								</div>

								<div className="btn_container">
									{!!updateErrors.general && (
										<ErrorWrap animate={1}>{updateErrors.general}</ErrorWrap>
									)}

									{updateSuccess && <SuccessWrap>{updateSuccess}</SuccessWrap>}

									<Button
										text={!!id ? "Update" : "Create"}
										clickHandler={this.handleSubmit}
										isLoading={updateLoading}
									/>
									{!!data.id && (
										<Button
											text={"Delete"}
											classes={"delete-btn"}
											clickHandler={() =>
												this.setState({
													showDeleteConfirmationDialog: true
												})
											}
											isLoading={updateLoading}
										/>
									)}
								</div>

								<DeleteConfirmationDialog
									show={this.state.showDeleteConfirmationDialog}
									deletionInProgress={this.state.deletionInProgress}
									id={id}
									itemTitle={title}
									handleDelete={this.handleDelete.bind(this)}
									handleDeleteRedirect={this.handleDeleteRedirect.bind(this)}
									handleClose={() =>
										this.setState({ showDeleteConfirmationDialog: false })
									}
									deleteErrors={this.state.deleteErrors}
									deleteSuccess={this.state.deleteSuccess}
								/>
							</React.Fragment>
						)}
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin,
		newsError: state.news.error,
		isLoading: state.news.isLoading,
		newsItem: state.news.news
	};
};

export default connect(mapStateToProps, { userTokenUpdate, userLogout, getNews })(AdminNewsForm);



// WEBPACK FOOTER //
// ./src/components/admin/news/AdminNewsForm.js